export enum Keys {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  ID_TOKEN = 'idToken',
}
